// extracted by mini-css-extract-plugin
export default {"icp":"daodao-brand-footer-Icp__icp--2-QkR","icp_text":"daodao-brand-footer-Icp__icp_text--3q8mc","record_filing_icon":"daodao-brand-footer-Icp__record_filing_icon--rj769"};